import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=a572cb42"
import script from "./Paginate.ts?vue&type=script&lang=ts&external"
export * from "./Paginate.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports